<svg viewBox="0 0 407.1 59.8">
    <polygon
        class="pattern_st0"
        points="319.6,59.8 327.9,39.9 349.2,39.9 340.9,59.8 "
    />
    <polygon
        class="pattern_st0"
        points="407.2,39.9 407.2,59.8 362.1,59.8 370.4,39.9 "
    />
    <polygon
        class="pattern_st0"
        points="316.4,59.8 313.1,59.8 321.5,39.9 324.7,39.9 "
    />
    <polygon
        class="pattern_st1"
        points="407.2,0 407.2,19.9 161,19.9 169.3,0 "
    />
</svg>
